module.exports = __webpack_public_path__ + "static/media/rene_grifthorst.40386e9f.jpg";